import { getOrganizations } from 'admin/actions/organization';
import { getPrivateMoneys } from 'admin/actions/private-moneys';
import { getShops } from 'admin/actions/shops';
import { getTerminals } from 'admin/actions/terminals';
import _Select, { addNullOption } from 'admin/components/atoms/Select';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import { toQueryParams } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';

const FilterSelectContainer = styled.div`
  ${LabeledSelect} {
    display: block;
    margin: 20px 0;
  }
  ${_Select} {
    margin-left: 15px;
    width: 300px;
  }
`;

const LabelText = styled.span`
  font-weight: 600;
`;

class FilterSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMoneyOption: {
        value: '',
      },
      selectedOrgOption: {
        value: '',
      },
      selectedShopOption: {
        value: '',
      },
      selectedTerminalOption: {
        value: '',
      },
      moneys: { rows: [] },
    };
  }

  componentWillMount() {
    const params = toQueryParams(
      {
        page: 1,
        perPage: 10000,
      },
      true
    );
    getPrivateMoneys(params)
      .then((json) => {
        this.setState({
          moneys: json,
        });
      })
      .catch((e) => {
        console.error('An error occurred in listing private moneys: ', e);
      });
  }

  onChangeMoneySelect = (op) => {
    if (!op.value) {
      this.resetSelectedMoneyOption();
    } else if (this.state.selectedMoneyOption.value !== op.value) {
      this.resetSelectedMoneyOption();
      this.setState({ selectedMoneyOption: op });
      const moneyId = op.value;
      const moneyName = op.label;
      this.props.onSelectPrivateMoney(moneyId, moneyName);
      if (this.props.target !== 'money') {
        this.props.getOrganizations(
          toQueryParams(
            {
              page: 1,
              perPage: 10000,
              privateMoneyId: moneyId,
            },
            true
          )
        );
      }
    }
  };

  onChangeOrganizationSelect = (op) => {
    if (!op.value) {
      this.resetSelectedOrgOption();
    } else if (this.state.selectedOrgOption.value !== op.value) {
      this.resetSelectedOrgOption();
      this.setState({ selectedOrgOption: op });
      const orgCode = op.value;
      const orgName = op.label;
      this.props.onSelectOrganization(orgCode, orgName);
      if (['shop', 'terminal'].indexOf(this.props.target) !== -1) {
        const params = toQueryParams(
          {
            page: 1,
            perPage: 5000,
            organizationCode: orgCode,
          },
          true
        );
        this.props.getShops(params);
      }
    }
  };

  onChangeShopSelect = (op) => {
    if (!op.value) {
      this.resetSelectedShopOption();
    } else if (this.state.selectedShopOption.value !== op.value) {
      this.resetSelectedShopOption();
      this.setState({ selectedShopOption: op });
      const shopId = op.value;
      const shopName = op.label;
      this.props.onSelectShop(shopId, shopName);
      if (this.props.target === 'terminal') {
        const params = toQueryParams(
          {
            shopId,
          },
          true
        );
        this.props.getTerminals(params);
      }
    }
  };

  onChangeTerminalSelect = (op) => {
    if (!op.value) {
      this.resetSelectedTerminalOption();
    } else if (this.state.selectedTerminalOption.value !== op.value) {
      this.resetSelectedTerminalOption();
      this.setState({ selectedTerminalOption: op });
      const termId = op.value;
      const termName = op.label;
      this.props.onSelectTerminal(termId, termName);
    }
  };

  resetSelectedMoneyOption = () => {
    this.setState({
      selectedMoneyOption: { value: '' },
    });
  };

  resetSelectedOrgOption = () => {
    this.setState({
      selectedOrgOption: { value: '' },
    });
    this.resetSelectedShopOption();
  };

  resetSelectedShopOption = () => {
    this.setState({
      selectedShopOption: { value: '' },
    });
    this.resetSelectedTerminalOption();
  };

  resetSelectedTerminalOption = () => {
    this.setState({
      selectedTerminalOption: { value: '' },
    });
  };

  render() {
    return (
      <FilterSelectContainer>
        <LabeledSelect
          labelText={<LabelText>マネー</LabelText>}
          options={addNullOption(
            this.state.moneys.rows.map((m) => ({
              label: m.name,
              value: m.id,
            }))
          )}
          value={this.state.selectedMoneyOption}
          onChange={this.onChangeMoneySelect}
        />
        {['organization', 'shop', 'terminal'].indexOf(this.props.target) !== -1 ? (
          <LabeledSelect
            labelText={<LabelText>組織</LabelText>}
            options={addNullOption(
              this.props.organizations.rows.map((org) => ({
                label: `${org.name} (${org.code})`,
                value: org.code,
              }))
            )}
            value={this.state.selectedOrgOption}
            onChange={this.onChangeOrganizationSelect}
          />
        ) : null}
        {['shop', 'terminal'].indexOf(this.props.target) !== -1 ? (
          <LabeledSelect
            labelText={<LabelText>店舗</LabelText>}
            options={addNullOption(
              this.props.shops.rows.map((shop) => ({
                label: shop.name,
                value: shop.id,
              }))
            )}
            value={this.state.selectedShopOption}
            onChange={this.onChangeShopSelect}
          />
        ) : null}
        {this.props.target === 'terminal' ? (
          <LabeledSelect
            labelText={<LabelText>ターミナル</LabelText>}
            options={addNullOption(
              this.props.terminals.map((term) => ({
                label: term.name && term.name.length > 0 ? term.name : term.id.slice(0, 8),
                value: term.id,
              }))
            )}
            value={this.state.selectedTerminalOption}
            onChange={this.onChangeTerminalSelect}
          />
        ) : null}
      </FilterSelectContainer>
    );
  }
}

FilterSelect.propTypes = {
  target: PropTypes.string.isRequired,
  onSelectOrganization: PropTypes.func,
  onSelectPrivateMoney: PropTypes.func,
  onSelectShop: PropTypes.func,
  onSelectTerminal: PropTypes.func,
  getOrganizations: PropTypes.func.isRequired,
  getShops: PropTypes.func.isRequired,
  getTerminals: PropTypes.func.isRequired,
  organizations: PropTypes.object,
  shops: PropTypes.object,
  terminals: PropTypes.array,
};

FilterSelect.defaultProps = {
  onSelectOrganization: () => {},
  onSelectPrivateMoney: () => {},
  onSelectShop: () => {},
  onSelectTerminal: () => {},
  organizations: { rows: [] },
  shops: { rows: [] },
  terminals: [],
};

const mapStateToProps = (state) => ({
  organizations: state.organization.organizations,
  shops: state.shop.shops,
  terminals: state.terminal.terminals,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getOrganizations,
      getShops,
      getTerminals,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FilterSelect);
